import {
  MarkerClustererOptions,
  ClusterIconStyle,
} from "@googlemaps/markerclustererplus";

type ClusterStyleFactory<T> = (assetsPath: string) => T;
const defaultClusterStyleFactory: ClusterStyleFactory<ClusterIconStyle> = (assetsPath: string) => {
  return {
    url: `${assetsPath}/Images/DistributorsMap/m1.png`,
    textColor: "#FFFFFF",
    fontFamily: "Roboto",
    textSize: 12,
    fontWeight: "bold",
    height: 55,
    width: 55,
  };
}

export const clusterStylesFactory: ClusterStyleFactory<MarkerClustererOptions["styles"]> = (assetsPath: string) => [
  {
    ...defaultClusterStyleFactory(assetsPath)
  },
  {
    ...defaultClusterStyleFactory(assetsPath)
  },
  {
    ...defaultClusterStyleFactory(assetsPath)
  },
  {
    ...defaultClusterStyleFactory(assetsPath)
  },
  {
    ...defaultClusterStyleFactory(assetsPath)
  },
];
